module.exports = __webpack_public_path__ + "img/Get Inspired photo.bfb22887.jpg";